var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vuestic-layout',{directives:[{name:"layout",rawName:"v-layout"}]},[_c('main',{staticClass:"va-layout gutter--lg fluid no-padding",attrs:{"slot":"content","id":"content","role":"main"},slot:"content"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }